<section class="root-container" *transloco="let t; read: 'building.technicalInstallation'">
  <header>
    <h2>
      <mat-icon class="text-middle">content_paste</mat-icon>
      {{ t('installationList') }}
    </h2>
  </header>

  <section>
    <table mat-table [dataSource]="activeInstallations$ | async" class="installations-table single-action-list">

      <ng-container matColumnDef="leftBorder">
        <th mat-header-cell *matHeaderCellDef class="left-border-cell"></th>
        <td mat-cell *matCellDef="let element" class="left-border-cell">
          <div></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="toggle">
        <th mat-header-cell *matHeaderCellDef class="fixed-width toggle"></th>
        <td mat-cell *matCellDef="let element" class="fixed-width toggle">
          <mat-slide-toggle
              [checked]="element.enabled ?? true"
              (change)="onToggleChange(element, $event.checked)"
              (click)="$event.stopPropagation()">
          </mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="installationType">
        <th mat-header-cell *matHeaderCellDef class="fixed-width installation-type"> {{ t('type') }} </th>
        <td mat-cell *matCellDef="let element" class="fixed-width installation-type">{{ t('installationType', {type: element.installationType}) }}</td>
      </ng-container>

      <ng-container matColumnDef="exigence">
        <th mat-header-cell *matHeaderCellDef class="fixed-width exigence"> {{ t('exigence') }} </th>
        <td mat-cell *matCellDef="let element" class="fixed-width exigence">{{ t('necessity', { necessity: element.necessity }) }}</td>
      </ng-container>

      <ng-container matColumnDef="installationDate">
        <th mat-header-cell *matHeaderCellDef class="fixed-width installation-date"> {{ t('installationDate') }} </th>
        <td mat-cell *matCellDef="let element" class="fixed-width installation-date"> {{ element.installationDate | date: 'dd.MM.yyyy' }} </td>
      </ng-container>

      <ng-container matColumnDef="lastControlDate">
        <th mat-header-cell *matHeaderCellDef class="fixed-width last-control-date"> {{ t('lastControlDate') }} </th>
        <td mat-cell *matCellDef="let element" class="fixed-width last-control-date"> {{ element.lastControlDate | date: 'dd.MM.yyyy' }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectInstallation(row)"></tr>
    </table>
  </section>

  <div class="horizontal-separator">
    <span>{{ t('inactiveInstallations') }}</span>
  </div>

  <section>
    <table mat-table [dataSource]="inactiveInstallations$ | async" class="installations-table single-action-list">

      <ng-container matColumnDef="leftBorder">
        <th mat-header-cell *matHeaderCellDef class="left-border-cell-inactive"></th>
        <td mat-cell *matCellDef="let element" class="left-border-cell-inactive">
          <div></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="toggle">
        <th mat-header-cell *matHeaderCellDef class="fixed-width toggle"></th>
        <td mat-cell *matCellDef="let element" class="fixed-width toggle">
          <mat-slide-toggle
              [checked]="element.enabled ?? false"
              (change)="onToggleChange(element, $event.checked)"
              (click)="$event.stopPropagation()">
          </mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="installationType">
        <th mat-header-cell *matHeaderCellDef class="fixed-width installation-type"></th>
        <td mat-cell *matCellDef="let element" class="fixed-width installation-type">{{ t('installationType', {type: element.installationType}) }}</td>
      </ng-container>

      <ng-container matColumnDef="exigence">
        <th mat-header-cell *matHeaderCellDef class="fixed-width exigence"></th>
        <td mat-cell *matCellDef="let element" class="fixed-width exigence">{{ t('necessity', { necessity: element.necessity }) }}</td>
      </ng-container>

      <ng-container matColumnDef="installationDate">
        <th mat-header-cell *matHeaderCellDef class="fixed-width installation-date"></th>
        <td mat-cell *matCellDef="let element" class="fixed-width installation-date"> {{ element.installationDate | date: 'dd.MM.yyyy' }} </td>
      </ng-container>

      <ng-container matColumnDef="lastControlDate">
        <th mat-header-cell *matHeaderCellDef class="fixed-width last-control-date"></th>
        <td mat-cell *matCellDef="let element" class="fixed-width last-control-date"> {{ element.lastControlDate | date: 'dd.MM.yyyy' }} </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="hidden-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectInstallation(row)"></tr>
    </table>
  </section>

</section>
